<script>
import AppointmentStore from "../../mixins/appointment-store";

export default {
    name: "ProgressBar",

    props: {
        title: {
            type: String,
            required: false,
        },
    },

    mixins: [AppointmentStore],

    computed: {
        currentStep() {
            return this.appointmentStore.activeStep
        },

        isRequestOffer() {
            return this.appointmentStore.isRequestOffer
        }
    }
}
</script>

<template>
<div class="vue-appointment-progress-bar">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 v-if="title" class="text-center">{{ title }}</h1>

                <ul>
                    <li :class="{
                        'active': currentStep === 1,
                    }">1. Mijn voertuig</li>
                    <li :class="{
                        'active': currentStep === 2,
                    }">2. Vestiging
                    <template v-if="!isRequestOffer">
                        & datum
                    </template></li>
                    <li :class="{
                        'active': currentStep === 3,
                    }">3. Services kiezen</li>
                    <li :class="{
                        'active': currentStep === 4,
                    }">4. Contactgegevens</li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>